import { render, staticRenderFns } from "./pringDialog.vue?vue&type=template&id=20baeac2&scoped=true"
import script from "./pringDialog.vue?vue&type=script&lang=js"
export * from "./pringDialog.vue?vue&type=script&lang=js"
import style0 from "./pringDialog.vue?vue&type=style&index=0&id=20baeac2&prod&lang=scss"
import style1 from "./pringDialog.vue?vue&type=style&index=1&id=20baeac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20baeac2",
  null
  
)

export default component.exports